import { createRootRoute, Outlet, useNavigate } from '@tanstack/react-router'
import { Toaster } from '@/components/ui/sonner'
import { AlertTriangle, ArrowBigLeftIcon } from 'lucide-react'
import { Button } from '@/components/custom/button'
import useUnauthorizedListener from '@/hooks/use-logout-listener'
import { useNavigationListener } from '@/hooks/use-navigation-listener'
import useCheckActiveApp from '@/hooks/use-check-active-app.js'
import { Page404 } from '@/components/page-404.jsx'
import { captureException } from '@/utils/posthog'
import { ExceptionCategory } from '@/constants/posthog'

export function RouteErrorBoundary({ error }) {
  const navigate = useNavigate()

  if (error) {
    captureException(error, {
      category: ExceptionCategory.Router,
    })
  }

  return (
    <div className="flex h-full flex-col items-center justify-center p-6">
      <div className="w-full max-w-xl overflow-hidden rounded-lg border border-border bg-card shadow-lg">
        <div className="flex items-center gap-3 border-b border-border bg-destructive/10 p-4">
          <AlertTriangle className="h-5 w-5 text-destructive" />
          <h3 className="text-lg font-semibold">Something went wrong</h3>
        </div>

        <div className="p-6">
          <p className="mb-4 text-muted-foreground">
            Oops! Đã có lỗi trong quá trình xử lý
          </p>
          <div className="flex justify-end gap-3">
            <Button
              onClick={() => navigate({ to: '/' })}
              className="flex items-center gap-2"
            >
              <ArrowBigLeftIcon className="h-4 w-4" />
              Trở lại
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}

export const Route = createRootRoute({
  component: Root,
  notFoundComponent: Page404,
  errorComponent: RouteErrorBoundary,
})

function Root() {
  useUnauthorizedListener()
  useNavigationListener()
  useCheckActiveApp()
  return (
    <>
      <Outlet />
      <Toaster richColors />
    </>
  )
}
